import { render, staticRenderFns } from "./contrastData.vue?vue&type=template&id=1941d1c0&scoped=true"
import script from "./contrastData.vue?vue&type=script&lang=js"
export * from "./contrastData.vue?vue&type=script&lang=js"
import style0 from "./contrastData.vue?vue&type=style&index=0&id=1941d1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941d1c0",
  null
  
)

export default component.exports